import ms202 from "./ms-202";
import ms203 from "./ms-203";
import ms211 from "./ms-211";
import ms224 from "./ms-224";
import ms232 from "./ms-232";
import jointaccounts from "./jointaccounts"
import termdeposit from "./termdeposit"
import recurringdeposit from "./recurringdeposit"
import pigmydeposit from "./pigmydeposit"
import specialinstruction from "./specialinstruction"
import standinginstruction from "./standinginstruction";
import accstatement from "./accstatement";
import minbalance from "./minbalance";
import overdraft from "./overdraft";
import freezeinformation from "./freezeinformation";
import leinmarking from "./leinmarking"
export default { ms202, ms203, ms211, ms224, ms232, jointaccounts, termdeposit, recurringdeposit, pigmydeposit, specialinstruction, standinginstruction, accstatement, minbalance, overdraft, freezeinformation, leinmarking };
